import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateTeacherSettingsBody } from "@shared-kernel/application/ports/admin/admin-repository";

export interface UpdateTeacherSettingsParams {
  teacherId: string;
  body: UpdateTeacherSettingsBody;
}

export const updateTeacherSettings = createAsyncThunk<string, UpdateTeacherSettingsParams, { extra: Partial<Dependencies> }>(
  "admin/teachers/updateSettings",
  async ({ teacherId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateTeacherSettings(teacherId, body);
    return teacherId;
  },
);

export const resetUpdateTeacherSettings = createAction("admin/teachers/resetUpdateSettings");
